export default __webpack_public_path__ + "img/6a7a6cc1ef4f7bc205990b50a80ed9ec.svg";